import React, { Component } from 'react'
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

export default class CreateAdminUser extends Component {
    render() {
        return (
            <div>
                <div className="text-center user-forms no-max-width navbar-default">
                    <h2>Create Blueconnect User</h2>

                    <Modal show={this.props.showModal} onHide={this.props.closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Blueconnect user created</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div><p>The user has been created. A welcome email including login details has been sent to the email address specified.</p></div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button bsStyle="primary" bsSize="large" onClick={this.props.closeModal}>Return to Blueconnect users view</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={this.props.errorMessage?true:false} onHide={this.props.closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Error in creating customer</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div><p style={{color: "red"}}>{this.props.errorMessage}</p></div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button bsStyle="primary" bsSize="large" onClick={this.props.closeModal}>Close</Button>
                        </Modal.Footer>
                    </Modal>

                    <form data-toggle="validator" role="form">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group col-sm-5">
                                    <label htmlFor="firstName" className="pull-left" style={{ color: this.props.errorField == 'firstName' ? 'red' : 'inherit' }}>First Name*</label>
                                    <input type="text" className="form-control" id="firstName" name="firstName" placeholder="First Name" onChange={this.props.updateFormState} />
                                    <div className="help-block with-errors"></div>
                                </div>

                                <div className="form-group col-sm-5 col-sm-offset-2">
                                    <label htmlFor="lastName" className="pull-left" style={{ color: this.props.errorField == 'lastName' ? 'red' : 'inherit' }}>Last Name*</label>
                                    <input type="text" className="form-control" id="lastName" name="lastName" placeholder="Last Name" onChange={this.props.updateFormState} />
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>

                            <div className="col-sm-12">
                                <div className="form-group col-sm-5">
                                    <label htmlFor="email" className="pull-left" style={{ color: this.props.errorField == 'email' ? 'red' : 'inherit' }}>Email*</label>
                                    <input type="email" className="form-control" id="email" name="email" placeholder="Email address" onChange={this.props.updateFormState} />
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>

                            <div className="col-sm-12">
                                <div className="form-group col-sm-8">
                                    <label className="pull-left confirmUser">
                                        <input type="checkbox" name="confirmUser" onChange={this.props.updateFormState} />
                                        &nbsp; I confirm I want to create a Blueconnect user.
                                    </label>
                                </div>
                            </div>
                        </div>

                        <button type="button" className="btn btn-primary" onClick={this.props.onCreateAdminUser}>Create User</button>
                    </form>
                </div>
            </div>
        )
    }
}